import { render, staticRenderFns } from "./furnitureshop-banner.vue?vue&type=template&id=6428da1b&"
import script from "./furnitureshop-banner.vue?vue&type=script&lang=js&"
export * from "./furnitureshop-banner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports